export const returnLabelStatusSolicitacao = status => {
  const label = {
    1: 'Pendente',
    2: 'Aprovado',
    3: 'Bloqueado',
    4: 'Insuficiencia',
    5: 'Aguardando Lider',
  };
  return label[status] || 'Não definido';
};

export const returnCorStatusSolicitacaoText = status => {
  const label = {
    Pendente: '#E47515',
    Analisando: '#24A95D',
    Aprovado: '#24A95D',
    Finalizado: '#24A95D',
    Bloqueado: '#D42929',
    Encerrado: '#D42929',
    Cancelado: '#D42929',
    Insuficiencia: '#EBAC00',
    EncerradoGestor: '#D42929',
    AguardandoLider: '#E47515',
  };
  return label[status] || '#707070';
};

export const returnCorStatusSolicitacaoOpacity = status => {
  const label = {
    Pendente: 'rgba(228, 117, 21,.7)',
    Analisando: 'rgba(36, 169, 93,.7)',
    Aprovado: 'rgba(36, 169, 93,.7)',
    Finalizado: 'rgba(36, 169, 93,.7)',
    Bloqueado: 'rgba(212, 41, 41,.7)',
    Encerrado: 'rgba(212, 41, 41,.7)',
    Cancelado: 'rgba(212, 41, 41,.7)',
    Insuficiencia: 'rgba(235, 172, 0,.7)',
    EncerradoGestor: 'rgba(212, 41, 41,.7)',
    AguardandoLider: 'rgba(228, 117, 21,.7)',
  };
  return label[status] || 'rgba(112, 112, 112,.7)';
};

export const returnStatusSolicitacaoLabel = status => {
  const label = {
    Pendente: 'Pendente',
    Analisando: 'Analisando',
    Aprovado: 'Aprovado',
    Finalizado: 'Finalizado',
    Bloqueado: 'Bloqueado',
    Encerrado: 'Encerrado',
    Cancelado: 'Cancelado',
    Insuficiencia: 'Insuficiencia',
    EncerradoGestor: 'Encerrado Gestor',
    AguardandoLider: 'Aguardando Lider',
  };
  return label[status] || '-';
};

export const returnStatusAtendimentoColor = status => {
  const color = {
    1: '#E47515',
    2: '#1B8046',
    3: '#D42929',
    4: '#E47515',
    5: '#E47515',
  };
  return color[status] || '#707070';
};

export const returnStatusAtendimentoLabel = status => {
  const label = {
    1: 'Analisando',
    2: 'Finalizado',
    3: 'Encerrado',
    4: 'Encerrado Gestor',
  };

  return label[status] || '';
};

export const returnStatusConsultaLabel = status => {
  const obj = {
    1: 'Pendente',
    2: 'Analisando',
    3: 'Reprovado BOT',
    4: 'Aprovado BOT',
    5: 'Timeout  BOT',
    6: 'Reprovado Análise',
    7: 'Aprovado  Análise',
    8: 'Validação  Manual',
  };
  return obj[status] || 'Não definido';
};

export const returnStatusConsultaColor = status => {
  const obj = {
    3: '#D42929',
    4: '#1B8046',
    6: '#D42929',
    7: '#1B8046',
  };
  return obj[status] || '#707070';
};
